const PAGE_SIZE  = process.env.REACT_APP_PAGE_SIZE;

export const getDefaultParams = () => {
  return { page: 1, page_size: PAGE_SIZE };
};
